import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Icon, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import swal from 'sweetalert2';
import { clearVerdicts, getVerdictScale } from 'actions/verdicts';
import VerdictFeedbackForm from 'containers/Verdict/Form/Partials/VerdictFeedbackForm';
import VerdictLevelForm from 'containers/Verdict/Form/Partials/VerdictLevelForm';
import { Button } from '@haldor/ui';
import '../Verdict.scss';

var VerdictForm = /*#__PURE__*/function (_Component) {
  _inherits(VerdictForm, _Component);

  var _super = _createSuper(VerdictForm);

  function VerdictForm(props) {
    var _this;

    _classCallCheck(this, VerdictForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.scale == null) {
        _this.props.getVerdictScale().then(function () {
          _this.initForm();
        });
      } else {
        _this.initForm();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "initForm", function () {
      _this.setState({
        level: null,
        feedback: null,
        loading: true,
        id: null
      }, function () {
        if (_this.props.duplicate == true) {
          var verdict = _this.props.sectionVerdicts.find(function (verdict) {
            return _this.props.activeStudent == verdict.userId;
          });

          _this.setState({
            level: verdict.scaleLevelId,
            feedback: verdict.feedback,
            loading: false
          });
        } else if (_this.props.userVerdicts != null && _this.props.userVerdicts.length > 0) {
          var latestVerdict = _this.props.userVerdicts[0];

          if (latestVerdict.status == 'VERDICT_DRAFT') {
            _this.setState({
              level: latestVerdict.scaleLevelId,
              feedback: latestVerdict.feedback,
              id: latestVerdict.id
            });
          }

          _this.setState({
            loading: false
          });
        } else if (_this.props.verdict != null) {
          _this.setState({
            level: _this.props.verdict.scaleLevelId,
            feedback: _this.props.verdict.feedback,
            id: _this.props.verdict.id,
            loading: false
          });
        } else {
          _this.setState({
            loading: false
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        values.scaleLevelId = _this.state.level;
        values.feedback = _this.state.feedback;
        values.scaleId = _this.props.scale.id;
        if (_this.state.id != null) values.id = _this.state.id;

        if (values.status == null) {
          values.status = 'VERDICT_PUBLISHED';
        }

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(values).then(function () {
            if (values.status == "VERDICT_PUBLISHED") {
              _this.setState({
                level: 0,
                feedback: ''
              });

              _this.props.reset();
            }

            _this.initForm();

            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteVerdictDraft", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(result) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(result.value != null)) {
                    _context.next = 5;
                    break;
                  }

                  _this.setState({
                    loading: true
                  });

                  _context.next = 4;
                  return _this.props.deleteVerdict(_this.props.userVerdicts[0].id);

                case 4:
                  _this.setState({
                    loading: false,
                    level: 0,
                    feedback: '',
                    id: null
                  });

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    var level = 0;
    var feedback = '';

    if (props.initialValues != null) {
      if (props.initialValues.scaleLevelId != null) {
        level = props.initialValues.scaleLevelId;
      }

      if (props.initialValues.feedback != null) {
        feedback = props.initialValues.feedback;
      }
    }

    _this.state = {
      level: level,
      feedback: feedback,
      loading: true,
      id: null
    };
    return _this;
  }

  _createClass(VerdictForm, [{
    key: "render",
    value: function render() {
      var _this$props$section,
          _this$props$section2,
          _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit;
      var _this$state = this.state,
          feedback = _this$state.feedback,
          level = _this$state.level,
          loading = _this$state.loading;

      if (loading) {
        return /*#__PURE__*/React.createElement("div", null);
      }

      var saveText = this.props.translate('save-verdict');
      var status = null;

      if (this.props.userVerdicts != null && this.props.userVerdicts.length > 0) {
        if (this.props.userVerdicts[0].status == 'VERDICT_DRAFT') saveText = this.props.translate('publish');
        status = this.props.userVerdicts[0].status;
      }

      var invalid_group = ((_this$props$section = this.props.section) === null || _this$props$section === void 0 ? void 0 : _this$props$section.deleted) || ((_this$props$section2 = this.props.section) === null || _this$props$section2 === void 0 ? void 0 : _this$props$section2.archived);
      var invalid = level == 0 || level == null || invalid_group;
      return /*#__PURE__*/React.createElement("div", null, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending",
        style: {
          height: '100%',
          top: 0
        }
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, invalid_group ? /*#__PURE__*/React.createElement("div", {
        className: "info-box"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert",
        bw: true
      }), " ", this.props.translate('No evaluations can be created because the group is archived or deleted'))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, this.props.scale != null ? /*#__PURE__*/React.createElement(VerdictLevelForm, {
        levels: this.props.scale.levels,
        value: level,
        onChange: function onChange(level) {
          return _this2.setState({
            level: level
          });
        },
        key: this.props.scale.id
      }) : null), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(VerdictFeedbackForm, {
        value: this.state.feedback,
        onChange: function onChange(feedback) {
          return _this2.setState({
            feedback: feedback
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row submit",
        style: {
          marginTop: '1.25rem',
          marginBottom: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: 'VERDICT_PUBLISHED'
          }));
        }),
        disabled: invalid
      }, saveText), this.props.edit == false ? /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: 'VERDICT_DRAFT'
          }));
        }),
        disabled: invalid
      }, this.props.translate('save-draft')) : null, status == 'VERDICT_DRAFT' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.deleteVerdictDraft();
        },
        type: "secondary"
      }, this.props.translate('Delete')) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })))));
    }
  }]);

  return VerdictForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    scale: state.Verdicts.scale,
    sectionVerdicts: state.Verdicts.section,
    section: state.sections.activeSection
  };
}

export default connect(mapStateToProps, {
  getVerdictScale: getVerdictScale,
  clearVerdicts: clearVerdicts
})(reduxForm({
  form: 'VerdictForm',
  destroyOnUnmount: true
})(VerdictForm));